module.exports = __webpack_public_path__ + "resources/img/main06_m.a129da3c822205898d4e18afede52d36.png";